import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export const QUICK_DIAL_GROUP_SETTINGS_CLASS_NAME = 'settings'

const revealedGroupSettingsStyle = { opacity: 1 } as const

const QuickDialViewParts = [
  'stack',
  'tabContainer',
  'scrollingList',
  'groupHeader',
  'header',
  'headerText',
  'headerButton',
  'headerIcon',
] as const

const helpers = createMultiStyleConfigHelpers(QuickDialViewParts)
export const QuickDialViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    stack: {
      height: 'full',
      borderRight: '2px solid',
      borderColor: 'border.muted',
    },
    tabContainer: {
      alignItems: 'center',
      width: 'full',
      height: '4.5rem',
      paddingX: '1rem',
      gap: '0.25rem',
      borderBottom: '2px solid',
      borderColor: 'border.muted',
    },
    scrollingList: {
      flex: '1',
      width: 'full',
      height: '70%',
      paddingLeft: '0.5rem',
      paddingTop: '0.5rem',
    },
    header: {
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 'full',
    },
    headerText: {
      ...textStyles[textStyleKeys.Body4_Bold],
      color: 'fg.muted',
    },
    groupHeader: {
      [`&:hover .${QUICK_DIAL_GROUP_SETTINGS_CLASS_NAME}, &:has(:focus-visible) .${QUICK_DIAL_GROUP_SETTINGS_CLASS_NAME}`]:
        revealedGroupSettingsStyle,
      '@media (hover: none)': {
        [`& .${QUICK_DIAL_GROUP_SETTINGS_CLASS_NAME}`]:
          revealedGroupSettingsStyle,
      },
    },
    headerButton: {
      boxSize: '0.75rem',
      minWidth: '0',
      bg: 'transparent',
      display: 'flex',
      opacity: 0,
      _hover: {
        bg: 'bg.emphasized',
      },
    },
    headerIcon: {
      boxSize: '0.75rem',
    },
  },
})

export const useQuickDialViewStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(QuickDialViewStyle, props) as MultiStyleType<
    typeof QuickDialViewParts
  >
}
